

















import Vue, { PropOptions } from 'vue';

type HeroAbout = Blok & {
  markedText: string;
  title: string;
  text: string;
  teamPhoto: BlokFieldAsset[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<HeroAbout>,
  },
});
